import React, { memo } from 'react'

import { Avatar } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

// The serializer hands back the :large avatar variant; a scrolled list would
// otherwise fetch every face in it up front.
const LAZY_IMAGE_PROPS = { loading: 'lazy' }

// One row of the likers list: who liked the model and when. Presentational - the
// time label arrives already formatted and localized.
function LikerRow({
  displayName, username = '', avatarUrl = null, timeLabel = '',
}) {
  return (
    <li className="liker-row">
      <Avatar
        className="liker-row__avatar"
        size="32"
        img={avatarUrl || ''}
        username={username}
        useSingleLetter
        imageProps={LAZY_IMAGE_PROPS}
      />
      <span className="liker-row__name cgt-body-base-semibold">{displayName}</span>
      <span className="liker-row__time cgt-caption">{timeLabel}</span>
    </li>
  )
}

LikerRow.propTypes = {
  displayName: string.isRequired,
  username: string,
  avatarUrl: string,
  timeLabel: string,
}

export default memo(LikerRow)
